/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Portal_Scanner_EnabledInputs */

const en_portal_scanner_enabled = /** @type {(inputs: Portal_Scanner_EnabledInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enabled`)
};

const de_portal_scanner_enabled = /** @type {(inputs: Portal_Scanner_EnabledInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enabled`)
};

const fr_portal_scanner_enabled = /** @type {(inputs: Portal_Scanner_EnabledInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enabled`)
};

const es_portal_scanner_enabled = /** @type {(inputs: Portal_Scanner_EnabledInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enabled`)
};

const it_portal_scanner_enabled = /** @type {(inputs: Portal_Scanner_EnabledInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enabled`)
};

const nl_portal_scanner_enabled = /** @type {(inputs: Portal_Scanner_EnabledInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enabled`)
};

const pl_portal_scanner_enabled = /** @type {(inputs: Portal_Scanner_EnabledInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enabled`)
};

const fi_portal_scanner_enabled = /** @type {(inputs: Portal_Scanner_EnabledInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enabled`)
};

const da_portal_scanner_enabled = /** @type {(inputs: Portal_Scanner_EnabledInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enabled`)
};

const sv_portal_scanner_enabled = /** @type {(inputs: Portal_Scanner_EnabledInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enabled`)
};

/**
* | output |
* | --- |
* | "Enabled" |
*
* @param {Portal_Scanner_EnabledInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const portal_scanner_enabled = /** @type {((inputs?: Portal_Scanner_EnabledInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Portal_Scanner_EnabledInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_portal_scanner_enabled(inputs)
	if (locale === "fr") return fr_portal_scanner_enabled(inputs)
	if (locale === "es") return es_portal_scanner_enabled(inputs)
	if (locale === "it") return it_portal_scanner_enabled(inputs)
	if (locale === "nl") return nl_portal_scanner_enabled(inputs)
	if (locale === "pl") return pl_portal_scanner_enabled(inputs)
	if (locale === "fi") return fi_portal_scanner_enabled(inputs)
	if (locale === "da") return da_portal_scanner_enabled(inputs)
	if (locale === "sv") return sv_portal_scanner_enabled(inputs)
	return en_portal_scanner_enabled(inputs)
});